import { NavLink, useLocation } from 'react-router-dom';
import { sidebarForArea, articleHref } from '../lib/content-loader';
import { areaForPath } from '../lib/sections';
import './Sidebar.css';

export function Sidebar() {
  const { pathname } = useLocation();
  const sections = sidebarForArea(areaForPath(pathname));

  return (
    <aside className="ds-nav" aria-label="Documentation sections">
      {sections.map(section => (
        <div key={section.id} className="ds-nav-section">
          <div className="ds-nav-section-head">
            <i className={`fa-solid ${section.icon}`}></i> {section.title}
          </div>
          {section.articles.map(article => (
            <NavLink
              key={article.slug}
              to={articleHref(article)}
              className={({ isActive }) =>
                isActive ? 'ds-nav-link active' : 'ds-nav-link'
              }
            >
              {article.title}
            </NavLink>
          ))}
        </div>
      ))}
    </aside>
  );
}
